// ABOUTME: hook for accessing the app theme context
// ABOUTME: provides access to the current material-ui theme with tenant branding and dark mode support

import { Theme } from "@mui/material/styles";
import { createContext, useContext } from "react";

export type ThemeMode = "light" | "dark" | "system";

interface ThemeContextType {
  theme: Theme;
  mode: ThemeMode;
  isDark: boolean;
  setMode: (mode: ThemeMode) => void;
}

export const ThemeContext = createContext<ThemeContextType | undefined>(
  undefined,
);

export const useAppTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useAppTheme must be used within a ThemeProvider");
  }
  return context;
};

// utility function to detect system dark mode preference
export const getSystemPrefersDark = (): boolean => {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
};

// utility function to resolve actual theme mode
export const resolveThemeMode = (mode: ThemeMode): "light" | "dark" => {
  if (mode === "system") {
    return getSystemPrefersDark() ? "dark" : "light";
  }
  return mode;
};
